export default __webpack_public_path__ + "static/media/modal.3176130a.jpg";